/* eslint-disable react-hooks/exhaustive-deps */

import "./ChannelAnalyzer.scss";

import {
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import ChannelAnalyzerTable from "./ChannelAnalyzerTable";
import CustomToast from "../../utils/cutomToast/CustomToast";
import DownloadIcon from "@mui/icons-material/Download";
import Loader from "../../utils/loader/Loader";
import Stepper from "../topicStartegyBuilder/Stepper";
import axios from "axios";
import { exportFlattenedChannelDataToCsv } from "../topicStartegyBuilder/JsonToCsv";
import { urlConstants } from "../../components/constants/globalConstants";

const ChannelAnalyzerMainPage = () => {
  const loca_tion = useLocation();
  const [loading, setLoading] = useState(false);
  const queryParams = new URLSearchParams(loca_tion.search);
  const jobId = queryParams.get("JobId");
  const channelAnalyzerMainPage = useRef(true);
  const [inputFileAttachments, setInputFileAttachments] = useState<any[]>([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [channelAnalyzerKeys, setChannelAnalyzerKeys] = useState<any>([]);
  const navigate = useNavigate();
  const handleChannelAnalyzerApi = useRef(true);
  const cancelPollingRef = useRef(false);
  const [stepper, setStepper] = useState<any[]>([]);
  const [handleStepper, setHandleStepper] = useState<string>("");
  const [groupChannelAnalyzer, setGroupChannelAnalyzer] = useState<any>([]);

  const handleChange = (event: any) => {
    setSelectedFile(event.target.value);
  };

  const handleErrorForJsonFetch = async (error: any) => {
    if (error.response) {
      if (error.response.status === 404) {
        CustomToast(
          error.response.data?.message ||
            "You didn't run the clusters in topic startegy builder.Please run this job.",
          "error"
        );
      } else if (error.response.status === 500) {
        CustomToast(error.response.data?.message || "Server Error.", "error");
      } else {
        CustomToast("Something went wrong.", "error");
      }
    } else {
      CustomToast(error.message || "Something went wrong.", "error");
    }
  };

  const handleAttachmentFiles = async () => {
    let response: any;
    let finalRes: any;

    try {
      response = await axios.get(
        `${urlConstants.PROMPT_URL}/create-intent-clusters?jobid=${jobId}`
      );
      finalRes = Object.values(response.data.data);
    } catch (error: any) {
      await handleErrorForJsonFetch(error);
      return;
    }

    if (finalRes.length > 0) {
      try {
        const attachmentFiles: { value: string; label: string }[] = [];
        for (const result of finalRes) {
          const outputPath = result?.output_data?.output_path;
          const algorithm = result?.metadata?.algorithm || "";
          const overlap = result?.metadata?.url_overlap || "";
          const country = result?.metadata?.country || "";
          const location = result?.metadata?.location || "";

          const label = `${algorithm}_${overlap} (${country} & ${location})`;

          if (outputPath) {
            attachmentFiles.push({
              value: outputPath,
              label: label,
            });
          }
        }
        setInputFileAttachments(attachmentFiles);
      } catch (error: any) {
        CustomToast(error?.response.message || "Server Error", "error");
      }
    }
  };

  const fetchJsonResponse = async (url: string) => {
    const res = await axios.get(url, {
      maxBodyLength: Infinity,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return res.data;
  };

  const handleSubmitForChannelAnalyzer = async (e: any) => {
    e.preventDefault();
    cancelPollingRef.current = true;
    await new Promise((resolve) => setTimeout(resolve, 50));
    cancelPollingRef.current = false;

    const requestBody = {
      input_file_path: selectedFile,
    };

    let response: any;
    let finalRes: any;

    try {
      response = await axios.post(
        `${urlConstants.PROMPT_URL}/channel-analyzer?jobid=${jobId}`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      finalRes = response.data;
    } catch (error: any) {
      CustomToast(
        error?.response?.data?.detail[0]?.msg ||
          error?.response?.data?.detail ||
          error?.response?.message ||
          "Server Error",
        "error"
      );
      setLoading(false);
      return;
    }

    if (finalRes.status === "success" || finalRes.status === "pending") {
      try {
        handelGetChannelAnalyzerKeys(
          true,
          finalRes?.metadata?.output_file_path
        );
      } catch (error: any) {
        CustomToast(
          error?.response?.data?.detail[0]?.msg || "Server Error",
          "error"
        );
        setLoading(false);
        return;
      }
    } else {
      CustomToast(finalRes?.output_data?.errors[0], "error");
    }
  };

  const handelGetChannelAnalyzerKeys = async (
    type: boolean,
    filePathURL: string
  ) => {
    try {
      setLoading(true);
      let finalRes: any;
      let response: any;
      if (type) {
        do {
          if (cancelPollingRef.current) {
            console.log("Polling stopped due to navigation or manual cancel.");
            return;
          }

          response = await fetchJsonResponse(
            `${urlConstants.PROMPT_URL}/channel-analyzer?jobid=${jobId}`
          );

          finalRes = Object.values(response.data); // Make sure this produces an array

          // Only wait if still processing
          if ([...finalRes].some((item: any) => item.status === "processing")) {
            await new Promise((resolve) => setTimeout(resolve, 10000));
          }
        } while (
          !cancelPollingRef.current &&
          [...finalRes].some(
            (item: any) =>
              item.status === "processing" || item.status === "pending"
          )
        );
      } else {
        response = await fetchJsonResponse(
          `${urlConstants.PROMPT_URL}/channel-analyzer?jobid=${jobId}`
        );

        finalRes = Object.values(response.data);
      }

      if (!finalRes || typeof finalRes !== "object") {
        console.error("Invalid response data structure.");
        return;
      }

      const fetchResults = await Promise.all(
        finalRes.map(async (value: any) => {
          if (value?.output_data?.download_url) {
            const downloadUrl = value?.output_data?.download_url;
            const outputPath = value?.output_data?.output_path;

            const channelAnalyzerKeys = await fetchJsonResponse(downloadUrl);

            return {
              outputPath,
              channels: channelAnalyzerKeys.channels || [],
            };
          } else {
            CustomToast(
              value?.output_data.errors[0] || "output file path not found",
              "error"
            );
          }
        })
      );

      const newGroupChannelAnalyzers = fetchResults.map((item) => ({
        [item.outputPath]: item.channels,
        output_file_path: item.outputPath,
      }));

      const newStepper = fetchResults.map((item) => item.outputPath);

      setGroupChannelAnalyzer(newGroupChannelAnalyzers);
      setStepper(newStepper);
      if (filePathURL) {
        setHandleStepper(filePathURL);
      } else {
        setHandleStepper(newStepper[0]);
      }
    } catch (error: any) {
      CustomToast(
        error?.response?.data?.detail[0]?.msg ||
          error?.response?.data?.detail ||
          "Error fetching channels",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (handleChannelAnalyzerApi.current && jobId) {
      handelGetChannelAnalyzerKeys(false, "");
      handleChannelAnalyzerApi.current = false;
    }
  }, [jobId]);

  useEffect(() => {
    if (channelAnalyzerMainPage.current && jobId) {
      handleAttachmentFiles();
      channelAnalyzerMainPage.current = false;
    }
  }, [jobId]);

  useEffect(() => {
    cancelPollingRef.current = true;

    return () => {
      cancelPollingRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (handleStepper) {
      setLoading(true);

      const timeoutId = setTimeout(() => {
        try {
          const currentChannels = groupChannelAnalyzer.find(
            (page: any) => page.output_file_path === handleStepper
          );
          const channelsObject = currentChannels
            ? currentChannels[handleStepper]
            : {};
          const flat: any[] = [];

          if (channelsObject && typeof channelsObject === "object") {
            Object.values(channelsObject).forEach((channel: any) => {
              const channelName = channel.channel_name;
              const channelRelevance = channel.channel_relevance;

              Object.values(channel.campaigns || {}).forEach(
                (campaign: any) => {
                  const campaignName = campaign.campaign_name;
                  const campaignRelevance = campaign.campaign_relevance;

                  campaign.clusters?.forEach((cluster: any) => {
                    flat.push({
                      channelName,
                      channelRelevance,
                      campaignName,
                      campaignRelevance,
                      cluster: cluster.cluster_name,
                      contentType: cluster.contentType,
                      title: cluster.title,
                      description: cluster.description,
                      clusterRelevance: cluster.cluster_relevance,
                      relatedKeywords: (cluster.related_keywords || []).join(
                        ", "
                      ),
                    });
                  });
                }
              );
            });
          }

          setChannelAnalyzerKeys(flat);
        } finally {
          setLoading(false);
        }
      }, 300); // adjust delay as needed (e.g., 300ms)

      return () => clearTimeout(timeoutId); // cleanup on unmount or dependency change
    }
  }, [handleStepper]);

  const ConvertToJSONToCSV = (json: any, filename: string, tab = 0) => {
    var csv = exportFlattenedChannelDataToCsv(json);
    const blob = csv && new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = blob ? URL.createObjectURL(blob) : "";

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    const hours = `${date.getHours()}`.padStart(2, "0");
    const minutes = `${date.getMinutes()}`.padStart(2, "0");
    const seconds = `${date.getSeconds()}`.padStart(2, "0");

    return `${year}-${month}-${day}-${hours}${minutes}${seconds}`;
  };

  return (
    <Box className="channel-analyzer-main-page-container">
      <Box className="channel-analyzer-inner-container">
        <Box className="channel-analyzer-title-container">
          <Box className="channel-analyzer-title">
            <Typography
              variant="h4"
              sx={{
                color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
                textAlign: "center",
                fontFeatureSettings: "'liga' off, 'clig' off",
              }}
            >
              Channel Analyzer
            </Typography>
          </Box>
        </Box>
        <Box className="channel-analyzer-main-page-controls">
          <FormControl fullWidth>
            <InputLabel id="attachment-select-label">Select File</InputLabel>
            <Select
              labelId="attachment-select-label"
              value={selectedFile}
              onChange={handleChange}
              sx={{ width: 450, height: 48 }}
              label="Select File"
            >
              {inputFileAttachments.map((file) => (
                <MenuItem key={file.value} value={file.value}>
                  {file.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={(e: any) => {
              handleSubmitForChannelAnalyzer(e);
            }}
          >
            Submit
          </Button>
        </Box>
        <Divider
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            alignSelf: "stretch",
          }}
        />
        <Loader spinning={loading}>
          <ChannelAnalyzerTable apiResponse={channelAnalyzerKeys} />
        </Loader>
        <Box className="footer-icons">
          <Button
            size="large"
            color="primary"
            variant="outlined"
            className="addicon"
            startIcon={<DownloadIcon />}
            disabled={channelAnalyzerKeys.length === 0}
            onClick={() =>
              ConvertToJSONToCSV(
                channelAnalyzerKeys,
                `channel-analyzer-${formatDate(new Date())}`,
                1
              )
            }
          >
            {" "}
            CSV
          </Button>
          <Button
            size="large"
            color="primary"
            variant="contained"
            className="addicon"
            onClick={() => {
              navigate("/channel-analyzer");
            }}
          >
            {" "}
            Back to Jobs
          </Button>
        </Box>
        <Stepper
          data={stepper || []}
          nextStepCsv={setHandleStepper}
          csvFile={handleStepper}
        />
      </Box>
    </Box>
  );
};

export default ChannelAnalyzerMainPage;
